import colors from 'styles/colors';

export default {
  variants: {
    pageHeading: {
      fontFamily: 'Rubik',
      color: colors.grey[900],
      textAlign: 'left',
      fontSize: '32px',
      fontWeight: 'bold',
    },
    table: {
      fontFamily: 'Rubik',
      textAlign: 'left',
      fontSize: '16px',
    },
  },
};
